import React from "react";
import { Box, Typography } from "@mui/material";
import BuildingsList from "../pages/building/BuildingsList";

const BuildingContainer = () => {
  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <Typography
        variant="h3"
        sx={{ mb: 1, fontWeight: "bold", color: "#333" }}
      >
        Welcome to Buildings!
      </Typography>
      <Typography variant="h6" sx={{ mb: 8, color: "#666" }}>
        Here, you can manage your buildings and view detailed, tabular
        information about your inventory.
      </Typography>
      <BuildingsList />
    </Box>
  );
};

export default BuildingContainer;
